var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row p-0"
  }, [_c('b-img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "static/img/analytics.jpeg",
      "alt": "Users & Interactions Graph"
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879e179a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Graph.vue
// module id = 919
// module chunks = 1